import type { ComponentType, SVGProps } from 'react';

import { ThumbsDown } from '@ui/uikit/components/icons/mono/ThumbsDown';
import { ThumbsUp } from '@ui/uikit/components/icons/mono/ThumbsUp';

export type ChoiceKeys = 'approved' | 'rejected';

export interface ChoiceConfig {
  iconColor: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  label: string;
}

export const CHOICES_BY_ID: Record<ChoiceKeys, ChoiceConfig> = {
  approved: {
    iconColor: 'var(--text-color-green)',
    icon: ThumbsUp,
    label: 'Approve',
  },
  rejected: {
    iconColor: 'var(--text-color-red)',
    icon: ThumbsDown,
    label: 'Reject',
  },
} as const;
